import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editDelivered, updateDelivered } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditDeliveredOn = props => {
  const dispatch = useDispatch()
  document.title = "Edit Delivered On"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editDelivered(id))
  }, [dispatch])

  const delivers = useSelector(state => state.deliveredOn)

  useEffect(() => {
    let delivery = []
    if (delivers && delivers.deliveredOn && delivers.deliveredOn.length > 0) {
      delivery = delivers.deliveredOn.filter(
        deliveredOn => deliveredOn.id == id
      )
    }
    if (delivery.length > 0) {
      setDetails(delivery[0])
    } else {
      props.history.push("/dropdown/delivered_on/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      delivery_id: details && details.delivery_id ? details.delivery_id : "",

      delivery_name:
        details && details.delivery_name ? details.delivery_name : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      delivery_name: Yup.string().required("Please enter place"),
    }),
    onSubmit: values => {
      values.delivery_id = id // delivery_id is from api thats why this needs to be same with "id"
      dispatch(updateDelivered(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.deliveredOn.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Delivered On" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editDeliversForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="delivers">Delivered On</Label>
                          <Input
                            name="delivery_name"
                            type="text"
                            id="delivers"
                            placeholder="Enter place"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.delivery_name || ""}
                          />
                          {validation.touched.delivery_name &&
                          validation.errors.delivery_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.delivery_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {delivers && delivers.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditDeliveredOn
